import React from 'react';
import { brand, ctaLabel, price } from '../data/content';
import { handleScrollClick } from './CtaButton';
export function TopBar() {
  return <header className="border-b border-hair bg-white" data-id="element-243" data-mp="231lttnhvrn30">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-3 px-5 md:px-8" data-id="element-244" data-mp="1y30tlo2mp3ek">
        <a href="#top" className="whitespace-nowrap font-display text-[15px] font-black tracking-tight text-brand md:text-[18px]" data-id="element-245" data-mp="1t5iusqibs4ka">
          {brand}
        </a>
        <a href="#offer" onClick={handleScrollClick} data-cta="offer" className="inline-flex h-10 shrink-0 items-center whitespace-nowrap rounded-lg bg-sun px-3 font-display text-[12px] font-extrabold tracking-[0.02em] text-ink transition-colors duration-150 ease-out hover:bg-sun-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand md:px-4 md:text-[13px]" data-id="element-246" data-mp="2quat224rx6jb">
          <span className="sm:hidden" data-id="element-247" data-mp="34qoa5a5eb5x9">GET IT · {price}</span>
          <span className="hidden sm:inline" data-id="element-248" data-mp="24ps2pgqjsyz">{ctaLabel}</span>
        </a>
      </div>
    </header>;
}